import { RoutingMemberItem } from './RoutingMemberItem';
import { useTranslation } from 'react-i18next';
import { UserRoutingProfileItemDTO } from '@/types/routingProfile';
import { List, Paper, Typography } from '@gapartners/ui';

type RoutingMembersDropdownProps = {
  members: UserRoutingProfileItemDTO[];
};

export function RoutingMembersDropdown({
  members,
}: RoutingMembersDropdownProps) {
  const { t } = useTranslation();
  return (
    <Paper variant="outlined" sx={{ width: '100%', overflow: 'hidden' }}>
      <List disablePadding sx={{ maxHeight: 288, overflow: 'auto' }}>
        {members.length === 0 ? (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ px: 2, py: 3, textAlign: 'center' }}
          >
            {t('pages.myProfile.noRoutingMembersFound')}
          </Typography>
        ) : (
          members.map(member => (
            <RoutingMemberItem key={member.connectId} member={member} />
          ))
        )}
      </List>
    </Paper>
  );
}
